<script>
  export let hotel_product_list;
  export let hotel_segment_name_list;
  export let index;
</script>

{#if hotel_product_list.length == 0}
  <p>loading....</p>
{:else}
  {#each hotel_segment_name_list[index] as hotel_segment_name, j}
    <h3>{hotel_segment_name}</h3>
    <div class="content_listBox">
      {#each hotel_product_list[index][j] as hotels}
        <div class="content_list">
          <a
            href={hotels.product_link}
            target="_blank"
            title={hotels.product_name}>
            <div class="imgBox">
              {#if hotels.left_tag}
                <div class="left_tags">{hotels.left_tag}</div>
              {/if}
              {#if hotels.right_tag}
                <div class="right_tags">{hotels.right_tag}</div>
              {/if}
              <div class="photo" style="background-image: url('{hotels.product_photo}'); background-size: cover; background-position: center center; background-repeat: no-repeat;"></div>
            </div>
            <div class="txtBox">
              <div class="title product_name_height">{hotels.product_name}</div>
              <div class="features feature_name_height">
                <ul>
                  <li>{hotels.product_feature}</li>
                </ul>
              </div>
              <div class="price_area">
                <div class="origin_price_container">
                  {#if hotels.origin_price}
                    <span>原價</span>
                    <span class="origin_price">{hotels.origin_price}</span>
                  {/if}
                </div>
                {#if hotels.current_price}
                  <div class="current_price_container">
                    <span
                      style="font-size: 14px; color: rgb(119, 119, 119);">NT$</span>
                    <span class="current_price">{hotels.current_price}</span>
                    <span
                      style="font-size: 14px; color: rgb(119, 119, 119);">起</span>
                  </div>
                {/if}
              </div>
            </div>
          </a>
        </div>
      {/each}
    </div>
  {/each}
{/if}
